import { render, staticRenderFns } from "./HistoricoLances.vue?vue&type=template&id=8786fd66&"
import script from "./HistoricoLances.vue?vue&type=script&lang=js&"
export * from "./HistoricoLances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports